import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { IGlobalHeaderProps } from '@amobee/component-library';
import { UserInfo } from './data/classes/user-info';
import { OktaAuthService } from '@okta/okta-angular';
import { ModalService } from './services/modal.service';
import { ModalComponent } from './common/components/modal/modal.component';
import { Subscription } from 'rxjs/internal/Subscription';
import { environment } from '../environments/environment';
import { AuthenticationService } from './services/authentication.service';
import { PromotionService } from './services/promotion.service';
import { CookieService } from 'ngx-cookie-service';
import { UserService } from './services/user.service';
import { BreadcrumbService } from './services/breadcrumb.service';
import { CampaignAdapter } from 'src/adapters/campaign-adapter';
import { MiscAdapter } from 'src/adapters/misc-adapter';

@Component({
    selector: 'tv-app-root',
    templateUrl: './tv-app.component.html'
})
export class AppComponent implements OnInit {
    public isAuthenticated: boolean;
    private authenticationStateSub: Subscription;
    public showGlobalHeader: boolean = false;
    public openUserProfile: boolean = false;
    // TODO: Update to use current user info
    public user: UserInfo = new UserInfo({});
    public excludeGlobalHeaderRoutes: string[] = ['/login', '/page-not-found', '/sign-up', '/welcome'];
    public globalHeaderProps: IGlobalHeaderProps = {
        //productName: React.createElement("a", { className: 'product-title', title: "Mediacorp", href: "#" }, "Mediacorp"),
        productName: environment.productName,
        accentColor: window.getComputedStyle(document.body).getPropertyValue('--theme-color'),
        menuItems: [],
        buttons: [{
            icon: 'Help',
            onClick: e => {
                window.open(this.isAgencyUser || this.isMultiAdvertiser ? environment.agencyHelpUrl : environment.helpUrl, '_blank');
            }
        }, {
            icon: 'User',
            menuItems: [
                {
                    label: '',
                    disabled: true
                },
                {
                    label: 'User Profile',
                    onClick: () => {
                        this.openUserProfile = true;
                    }
                },
                {
                    label: 'Logout',
                    onClick: () => {
                        this.oktaAuth.logout().then(() => {
                            this.authenticationService.updateAuthenticationState(false);
                            // this.cookieService.delete('sme_access_token', '/', window['__tvbEnv'].cookieDomain);
                        }).catch((err) => console.log(err));
                    }
                }
            ]
        }],
        navbarZIndex: 1,
        dimmerZIndex: 100
    };
    public productImage = "./assets/product_logo@30px.svg";
    public productName = environment.platform;
    public breadcrumb: Array<any> = [];
    isMultiAdvertiser: boolean = false;
    isAgencyUser: boolean = false;

    @ViewChild(ModalComponent, { static: true }) modalComponent: ModalComponent;

    constructor(
        private modalService: ModalService,
        private router: Router,
        private oktaAuth: OktaAuthService,
        private breadcrumbService: BreadcrumbService,
        private authenticationService: AuthenticationService,
        private promotionService: PromotionService,
        private userService: UserService,
        private cookieService: CookieService,
        private campaignAdapter: CampaignAdapter,
        private miscAdapter: MiscAdapter
    ) {
        // Subscribe to authentication state changes
        this.authenticationStateSub = this.authenticationService.authenticationState.subscribe((isAuthenticated: boolean) => {
            this.isAuthenticated = isAuthenticated;
            if (isAuthenticated) {
                this.oktaAuth.getAccessToken().then((token: string) => {
                    if (!this.cookieService.check('sme_lastToken') || this.cookieService.get('sme_lastToken') != token) {
                        let expDate = new Date(Date.now() + (12 * 60 * 60 * 1000)); // 12 hour cookie
                        let ssoLoginUrl = window['__tvbEnv'].SSOManagerUrl + '/web/login?accessToken=' + token + '&app=' + window['__tvbEnv'].appAuthorityName;
                        document.getElementById('loginFrame').setAttribute('src', ssoLoginUrl);
                        this.cookieService.set('sme_lastToken', token, expDate, '/', window['__tvbEnv'].cookieDomain, true, 'None');
                    }
                    this.userService.getUser().then(user => {
                        this.user = user;
                        this.userService.getUserWithDetails().then(user =>
                            this.user = user
                        );
                    });
                    this.promotionService.getPromotion();
                });
            }
        });

        // On route change to certain routes, do not show the global header
        router.events.forEach((event) => {
            if (event instanceof NavigationEnd) {
                const url = event['urlAfterRedirects'].substring(0, event['urlAfterRedirects'].indexOf('/', 1));
                this.showGlobalHeader = url.length > 1 && !this.excludeGlobalHeaderRoutes.includes(url);
            }
        });
    }

    public ngOnInit() {
        this.campaignAdapter.isMultiAdvertiser().then(isMultiAdvertiser => {
            this.isMultiAdvertiser = isMultiAdvertiser;
            if (!isMultiAdvertiser) {
                this.campaignAdapter.getCustomerId().then((cid) => {
                    if (cid) {
                        this.miscAdapter.isCreditAccountNumberApproved(cid.toString()).then(isAgencyUser => this.isAgencyUser = isAgencyUser).catch((err) => {
                            console.log(err);
                        });
                    }
                });
            }
        });
        this.modalService.modal = this.modalComponent;
        this.breadcrumbService.sharedBreadcrumb.subscribe(breadcrumb => {
            setTimeout(() => {
                this.breadcrumb = breadcrumb;
            });
        });
    }
}
